import KeyboardFocusable from '../KeyboardFocusable';

import Controls from './Controls';

export default class TutorialDialog extends Controls {
    namespace = 'tutorialDialog';
    constructor() {
        super();
        this._items = [];
    }

    init() {
        this.collectElements();
        this.focus();
    }

    destroy() {
        this._items = [];
    }

    collectElements() {
        this._items = [];
        const elements = document.querySelectorAll('.dialog-tutorial-btn');

        elements.forEach(elem => {
            this._items.push(
                new KeyboardFocusable(elem)
            );
        });
    }

    focus() {
        if (this._items[this._currentIndex]) {
            this._items[this._currentIndex].focus();
        }
    }

    enter() {
        this._items[this._currentIndex].el.click();
    }

    isPossibleUp() {
        return this._currentIndex !== 0 && this._items.length !== 0;
    }

    isPossibleDown() {
        return this._currentIndex !== this._items.length - 1 && this._items.length !== 0;
    }

    up() {
        if (this.isPossibleUp()) {
            this.unfocus();
            this._currentIndex -= 1;
            this.focus();
        }
    }

    down() {
        if (this.isPossibleDown()) {
            this.unfocus();
            this._currentIndex += 1;
            this.focus();
        }
    }
}
